import { transformRideRequestFields } from '../../utils';

export const getRideRequestOptions = (state) =>
  transformRideRequestFields(state?.healthOrganizations?.HOPreferences?.rideRequestFields);
